import { useTranslation } from 'next-i18next';

import { useCharacterPost } from '@hooks/useCharacterPost';

import Empty from '@components/common/Empty';
import { PaginationIterator } from '@components/common/Pagination';
import Pad from '@components/layout/Pad';
import ImageModal from '@components/modal/ImageModal';

import { ICharacterPost, IChatCharacter, IPagination } from '@model';
import { UsePaginationQueryResult } from '@utils/query';

import CharacterPost from './CharacterPost';

interface CharacterCommunityListProps {
  query: UsePaginationQueryResult<IPagination<ICharacterPost>>;
  character: IChatCharacter;
}
const CharacterCommunityList = ({
  query,
  character,
}: CharacterCommunityListProps) => {
  const { t } = useTranslation();
  const userId = character.player?.user_id;

  const {
    handleActionSheet,
    likePost,
    pollVote,
    handleNavigatePostDetail,
    handleClickImg,
    closeImageModal,
    isImageModalOpen,
    selectedImage,
  } = useCharacterPost();

  return (
    <div>
      <PaginationIterator name="user-post-list" query={query} border>
        {(item) => {
          return (
            <Pad
              onClick={() =>
                handleNavigatePostDetail(character.id, item.id, userId)
              }
            >
              <CharacterPost
                playerId={character?.player?.user_id}
                {...item}
                clip
                onLike={(post: ICharacterPost) => likePost(post, character.id)}
                onPollVote={(post: ICharacterPost) => pollVote(post, character.id)}
                handleActionSheet={(value, id) =>
                  handleActionSheet(value, id, userId, character.id)
                }
                handleClickImg={handleClickImg}
                imageHeight={400}
                commentPreview={item.previewComments}
              />
            </Pad>
          );
        }}
      </PaginationIterator>
      <Empty query={query}>
        <p>{t('아직 후기가 없어요.')}</p>
        <p>{t('캐릭터에게 바라는 점을 적거나')}</p>
        <p>{t('재미있던 순간을 자랑해 주세요!')}</p>
      </Empty>
      {selectedImage && (
        <ImageModal
          open={isImageModalOpen}
          image={selectedImage}
          onClose={closeImageModal}
        />
      )}
    </div>
  );
};

export default CharacterCommunityList;
